import { parseQuerystring } from '../parseQuerystring';

// use closure, do not expose function in window, but keep in memory
let done: (() => void) | null = null;
let track: (() => void) | null = null;

export const handleDone = (): {
  initDone: (fn: any, initTracking: any) => void;
  callDone: () => void;
} => ({
  initDone: (fn: any, initTracking: any) => {
    done = fn;
    track = initTracking;
  },
  callDone: () => {
    if (typeof track === 'function') {
      track();
    }

    setTimeout(() => {
      if (typeof done === 'function') {
        done();
      }
      done = null;
      track = null;
    }, 1000);
  },
});

export const isEnvDev = (): boolean =>
  parseQuerystring({ search: 'env' }) === 'dev';

export const getDeepLink = (error_description: string = 'forgot_password') => {
  const redirectUri = parseQuerystring({ search: 'redirect_uri' });
  return `${redirectUri}?error=login_required&error_description=${error_description}`;
};

export const getLanguageLocaleForMobile = (): Record<string, string> => {
  const queryStringLocale = parseQuerystring({ search: 'locale' });
  const [language = '', locale = ''] = queryStringLocale.split('-');
  return { language, locale: locale.toLowerCase() };
};
